<template>
    <div class="productItem" :class="layoutClass">
        <div class="col-12" itemscope itemtype="https://schema.org/Product">
            <div class="bookImage">
                <div class="centerDiv">
                    <div class="bookInner" :class="getClasses()">
                        <a :href="`/${product.slug}/`" class="image">
                            <img src="/images/thema_groeivoordeel_klein.png" class="bulkDiscountImageOverview" v-if="product.show_stapelkorting" alt="groeivoordeel" />
                            <img :src="product.thumbnail"
                                 :data-src="product.thumbnail"
                                 :alt="altTag"
                                 itemprop="image">
                        </a>
                    </div>
                </div>
            </div>
            <div class="bookInfo equalHeight-1">
                <a :href="`/${product.slug}/`">
                    <span class="title-7 semiBoldFont col-12 titleColor" itemprop="name" v-html="this.product.title"></span>
                </a>
                <div class="paragraph small blueDarkColor col-12" v-text="this.product.authors"></div>
                <div class="paragraph small blueDarkColor col-12 mt10">
                    <strong>Type: <span v-text="this.product.type"></span></strong> <br/>
                    <span itemprop="description" v-html="this.product.description_short"></span>
                </div>
                <div class="paragraph small blueDarkColor col-12 mt10">
                    <a itemprop="url" :href="`/${product.slug}/`">
                        Lees meer
                        <i class="fa fa-arrow-right ml10"></i>
                    </a>
                </div>
                <span itemprop="gtin13" :content="this.product.code"></span>
            </div>
            <div class="bookOrder equalHeight-3" itemprop="offers" itemscope="" itemtype="https://schema.org/Offer">
                <div class="label ebook" v-if="this.product.is_ebook">E-book</div>
                <div class="label" v-else v-show="this.hasFreeDelivery || this.product.no_delivery_costs === 1">Gratis verzending</div>
                <star-rating v-if="this.product.rating > 0"
                             :increment="0.5"
                             :rating="this.product.rating"
                             :read-only="true"
                             :star-size="15"
                             :show-rating="false"
                             active-color="#ff9b00">
                </star-rating>
                <span itemprop="priceCurrency" content="EUR" class="dpn">EUR</span>
                <span itemscope="" itemprop="aggregateRating" itemtype="https://schema.org/AggregateRating" v-if="this.product.rating > 0" class="d-none">
                    <span itemprop="itemReviewed" itemscope itemtype="https://schema.org/Book">
                        <span itemprop="name" :content="this.product.title"></span>
                    </span>
                    <span itemprop="ratingValue">{{ this.product.rating }}</span>
                    <span itemprop="worstRating">1</span>
                    <span itemprop="bestRating">5</span>
                    <span itemprop="reviewCount">{{ this.product.ratingCount }}</span>
                </span>
                <div v-if="this.product.price_calculation != this.product.original_price" class="title-6 mt10 semiBoldFont col-12 blueDarkColor">
                    <span class="fs15 mr5 linethrough" v-text="formatPriceSimple(this.product.original_price)"></span>
                    <span v-text="this.product.price"></span>
                </div>
                <div v-else class="title-6 mt10 semiBoldFont col-12 blueDarkColor" v-text="this.product.price"></div>
                <span itemprop="price" :content="formatDecimalPrice(this.product.price_calculation)" class="dpn"></span>
                <div class="col-12 mt10 flex">
                    <add-to-cart
                        :product="product"
                        route-cart="/cart/"
                        currency="EUR"
                        v-if="inStock"
                        :modal-id="'add-to-cart-modal-' + product.id"
                        :availability="product.availabilityInfo"
                        :lang="{
                          add_to_cart: addToCartText,
                          continue_shopping: label('shop.cart.continue_shopping'),
                          go_to_cart: label('shop.cart.go_to_cart'),
                          in_stock: label('shop.product.stock.in_stock'),
                          out_of_stock: label('shop.product.stock.out_of_stock'),
                          low_stock: label('shop.product.stock.low_stock'),
                    }"
                    ></add-to-cart>
                    <favorite-button :product-id="this.product.id" :padding="inStock">
                    </favorite-button>
                </div>
                <div class="col-12 mt10" v-show="!product.is_event">
                    <div class="paragraph col-12 small" :class="availabilityColor">
                        <i class="fa" :class="availabilityIcon"></i>
                        {{ product.availabilityInfo.label }}
                    </div>
                    <span itemprop="availability" :content="availabilityMeta"></span>
                </div>
                <div v-show="product.is_event && !inStock">
                    <div class="col-12 small paragraph redColor">
                        <i class="fa fa-times"></i>
                        {{ label('shop.overview.cannot_register') }}
                    </div>
                </div>
                <div class="col-12 mt10">
                    <div class="otherBook col-12" v-for="(linkedProduct, index) in product.linked_products">
                        <a :href="`/${linkedProduct.translations[0].slug}/`" v-text="linkedProduct.type.description"></a>
                        <span v-text="formatPriceSimple(linkedProduct.price)"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
//import ProductToCart from "./ProductToCart";
import StarRating from 'vue-star-rating';
import FavoriteButton from "./FavoriteButton";
import translations from "../mixins/translations";

export default {
    name: "Product",
    mixins: [translations,],
    components: {
        StarRating,
        FavoriteButton
        // ProductToCart
    },
    props: {
        product: {
            required: true,
            type: Object,
        },
        layoutClass: {
            required: false,
            default: "row"
        },
        lang: {
            required: false,
            type: Object,
        }
    },
    computed: {
        inStock() {
            if(this.product.is_event) return this.product.can_register;

            return ![
                'not-available',
            ].includes(this.product.availabilityInfo?.availability);
        },
        altTag() {
            return this.product.alt;
        },
        addToCartText() {
            return this.product.availabilityInfo.button ?? this.label('shop.product.detail.add_to_order');
        },
        availabilityColor() {
            let colors = {
                'not-available': 'redColor',
                'soon': 'orangeColor',
                'available': 'greenColor',
            };
            return colors[this.product.availabilityInfo.availability] ?? colors['not-available'];
        },
        availabilityMeta(){
            let stock = {
                'not-available': 'OutOfStock',
                'soon': 'PreOrder',
                'available': 'InStock',
            };
            return stock[this.product.availabilityInfo.availability] ?? stock['not-available'];
        },
        availabilityIcon() {
            return this.product.availabilityInfo.availability == 'not-available' ? 'fa-times' : 'fa-check';
        },
        canAddToCart() {
            return true;
        },
        hasFreeDelivery() {
            return this.product.price_calculation >= 2000 && !this.product.is_event;
        }
    },
    methods: {
        formatPriceSimple(price) {
            return (parseFloat(price) / 100).toLocaleString(
                undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}
            );
        },
        formatDecimalPrice(price){
            return (parseFloat(price) / 100);
        },
        getClasses(){
            let classes = "";
            if(this.product.type == 'Waaier' || this.product.is_event){
                classes += "waaier ";
            }
            if(this.product.disable_shadow == 1 || this.product.is_event){
                classes += "hide-shadow ";
            }
            return classes;
        }
    },
    mounted() {
        //window.LazyLoad.update();
    }
}
</script>
